module.exports = __webpack_public_path__ + "static/media/cw_forum_discussion_topic.99c2a681.png";